
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EdiConfigurationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EdiConfiguration"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderDownloadsEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salesOrderTemplate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salesOrderLineTemplate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salesInvoiceTemplate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salesInvoiceLineTemplate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ordersDestination"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"invoicesDestination"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ediType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"passwordSet"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"autoPostPayments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"keyPresent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"usePrices"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderNotificationEmailFrom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderNotificationRecipients"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accountsNotificationRecipients"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sendAcknowledgement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salesAcknowledgementTemplate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"salesAcknowledgementEmailFrom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salesAcknowledgementSubject"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salesAcknowledgementMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customerStrategy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"automaticExport"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eligibleOrderOrigins"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":942}};
    doc.loc.source = {"body":"fragment EdiConfigurationFragment on EdiConfiguration {\n  id\n  uuid\n  concurrencyVersion\n  orderDownloadsEnabled\n  enabled\n  name\n  salesOrderTemplate\n  salesOrderLineTemplate\n  salesInvoiceTemplate\n  salesInvoiceLineTemplate\n  ordersDestination\n  invoicesDestination\n  warehouse {\n    id\n    uuid\n    concurrencyVersion\n    description\n  }\n  paymentMethod {\n    id\n    concurrencyVersion\n    uuid\n    description\n  }\n  serviceUrl\n  ediType\n  username\n  passwordSet\n  autoPostPayments\n  keyPresent\n  usePrices\n  orderNotificationEmailFrom\n  orderNotificationRecipients\n  accountsNotificationRecipients\n  sendAcknowledgement\n  salesAcknowledgementTemplate {\n    id\n    uuid\n    concurrencyVersion\n    name\n  }\n  salesAcknowledgementEmailFrom\n  salesAcknowledgementSubject\n  salesAcknowledgementMessage\n  customerStrategy\n  customer {\n    id\n    uuid\n    concurrencyVersion\n    reference\n    name\n  }\n  automaticExport\n  eligibleOrderOrigins\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["EdiConfigurationFragment"] = oneQuery(doc, "EdiConfigurationFragment");
        
